var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLineDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58301 19.0129C2.23792 19.0129 1.95801 18.7329 1.95801 18.3879C1.95801 18.0428 2.23792 17.7629 2.58301 17.7629H19.2497C19.5948 17.7629 19.8747 18.0428 19.8747 18.3879C19.8747 18.7329 19.5948 19.0129 19.2497 19.0129H2.58301ZM10.9163 1.09619C10.5713 1.09619 10.2913 1.37611 10.2913 1.72119V11.8791L7.19159 8.77936C6.94742 8.53519 6.55192 8.53519 6.30784 8.77936C6.06376 9.02353 6.06367 9.41903 6.30784 9.66311L10.4745 13.8298C10.5966 13.9519 10.7561 14.0129 10.9164 14.0129C11.0768 14.0129 11.2363 13.9519 11.3583 13.8298L15.525 9.66311C15.7692 9.41894 15.7692 9.02344 15.525 8.77936C15.2808 8.53528 14.8853 8.53519 14.6413 8.77936L11.5415 11.8791V1.72119C11.5415 1.37611 11.2614 1.09619 10.9163 1.09619Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineDown);
export default __webpack_public_path__ + "static/media/arrow-line-down.f6e38772bc851a72367f318f3c0f7ac9.svg";
export { ForwardRef as ReactComponent };